// Time-tracking window helpers (mirror of server/utils/timeWindow.js).
// Staff may log time on the shift day and the day after the shift's end date
// (Europe/Berlin). An end time at or before the start time = overnight shift.

const toMins = (t) => parseInt(String(t).slice(0, 2), 10) * 60 + parseInt(String(t).slice(3, 5), 10);

export function berlinToday(now = new Date()) {
  return new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Berlin' }).format(now);
}

export function addDays(dateStr, n) {
  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d + n)).toISOString().slice(0, 10);
}

export function isOvernight(startTime, endTime) {
  return toMins(endTime) <= toMins(startTime);
}

export function slotEndDate(slot) {
  return isOvernight(slot.start_time, slot.end_time) ? addDays(slot.date, 1) : slot.date;
}

export function canStaffEdit(slot, now = new Date()) {
  const today = berlinToday(now);
  return today >= slot.date && today <= addDays(slotEndDate(slot), 1);
}

// Query string of /time-tracking: ?slot=<id> (Log time deep link) and
// ?view=not-logged&start=&end= (admin digest link)
export function parseDeepLink(search) {
  const p = new URLSearchParams(search);
  const slotId = Number(p.get('slot'));
  const isDate = (v) => /^\d{4}-\d{2}-\d{2}$/.test(v || '');
  return {
    slotId: Number.isInteger(slotId) && slotId > 0 ? slotId : null,
    view: p.get('view') === 'not-logged' ? 'not-logged' : null,
    start: isDate(p.get('start')) ? p.get('start') : null,
    end: isDate(p.get('end')) ? p.get('end') : null,
  };
}

// First day of the month containing dateStr, as a local Date (for the month navigator)
export function monthStartOf(dateStr) {
  const [y, m] = dateStr.split('-').map(Number);
  return new Date(y, m - 1, 1);
}

// Clock-out timestamp: on the next day when it is at or before clock-in (overnight)
export function clockOutDate(dateStr, inTime, outTime) {
  return isOvernight(inTime, outTime) ? addDays(dateStr, 1) : dateStr;
}
